export const FETCH_LOGIN = 'LOGIN'
export const FETCH_LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const FETCH_RENEW_PASSWORD = 'FETCH_RENEW_PASSWORD'
export const FETCH_RENEW_PASSWORD_SUCCESS = 'FETCH_RENEW_PASSWORD_SUCCESS'
export const FETCH_LOGOUT = 'LOGOUT'
export const FETCH_LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const PASSWORD_USER_RECOVER = 'SAVE_USER'

export const login = (values) => {
    return {
        type: FETCH_LOGIN,
        payload: {
           params: values
        }
    }
}

export const logout = (values) => {
   return {
       type: FETCH_LOGOUT,
       payload: {
          params: values
       }
   }
}

export const renewPassword = (refreshToken) => {
    return {
        type: FETCH_RENEW_PASSWORD,
        payload: {
           params: refreshToken
        }
    }
 }

export const passwordRecover = (values) => {
    return {
        type: PASSWORD_USER_RECOVER,
        payload: {
           params: values
        }
    }
}

